var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isImage(_vm.name)
    ? _c("img", {
        staticClass: "app-icon",
        attrs: { src: _vm.getURL(_vm.name) }
      })
    : _c(_vm.name, { tag: "component", staticClass: "app-icon" })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }